<template>
  <!-- D: 스와이퍼 전체 -->
  <div class="swiper-wrap">
    <!-- D: 스와이퍼 Vue 컴포넌트 영역 -->
    <div class="swiper product-swiper" data-swiper-id="swiperCol2">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(list, idx) in data.swiper.data"
          :key="`slideSlide-${idx}`"
        >
          <!-- D: 메인 전용 상품 컴포넌트 -->
          <div
            class="c-main-product-card"
            v-for="(item, itemIdx) in list"
            :key="`item-${itemIdx}`"
          >
            <div class="product-thumb">
              <button
                type="button"
                class="thumb-button"
                @click="btnCmd('detail', item)"
              >
                <div class="product-img">
                  <img
                    v-if="
                      item.imgUrl == null ||
                      item.imgUrl == '' ||
                      item.noImgFlag == true
                    "
                    class="no-image"
                    src="@/assets/images/common/img_no_product.svg"
                    alt="No Image"
                  />
                  <img
                    v-else
                    :src="item.imgUrl"
                    alt=""
                    @error="() => (item.noImgFlag = true)"
                  />
                </div>
                <div class="thumb-bottom">
                  <p class="text">제품상세보기</p>
                  <i class="c-icon icon-plus"></i>
                </div>
              </button>
            </div>
            <div class="product-info">
              <div
                :class="
                  item.setgdYn == 'Y' ||
                  item.zzlqdCls != '' ||
                  item.zzlqdtyCls != undefined
                    ? 'c-product-badge'
                    : ''
                "
              >
                <!-- 세트상품 여부 -->
                <span v-if="item.setgdYn == 'Y'" class="badge type-skyblue"
                  >SET 제품</span
                >
                <!-- 액구분 -->
                <span v-if="item.zzlqdCls == 'A'" class="badge type-purple"
                  >주제</span
                >
                <span v-if="item.zzlqdCls == 'B'" class="badge type-mint"
                  >경화제</span
                >
                <span v-if="item.zzlqdCls == 'C'" class="badge type-blue"
                  >경화촉진제</span
                >
                <span v-if="item.zzlqdCls == 'D'" class="badge type-violet"
                  >회석제
                </span>
                <!-- 액형 구분 -->
                <span v-if="item.zzlqdtyCls == 'A'" class="badge type-olive"
                  >1액형</span
                >
                <span v-if="item.zzlqdtyCls == 'B'" class="badge type-olive"
                  >2액형</span
                >
                <span v-if="item.zzlqdtyCls == 'C'" class="badge type-olive"
                  >3액형</span
                >
              </div>
              <div class="c-product-category">
                <span class="path">{{ item.prodh1t }}</span>
                <!-- 제품 계층구조 Lv1 -->
                <span class="path">{{ item.prodh2t }}</span>
                <!-- 제품 계층구조 Lv2 -->
                <span class="path">{{ item.prodh3t }}</span>
                <!-- 제품 계층구조 Lv3 -->
              </div>
              <div class="product-code">{{ item.matnr }}</div>
              <!-- 제품코드 -->
              <strong class="product-name">{{ item.zzmaktx }}</strong>
              <!-- 제품명 -->
              <div class="info-bottom">
                <p class="price">
                  <strong class="system">{{
                    Number(item.kbetr).toLocaleString()
                  }}</strong
                  >원
                </p>
                <!-- 가격 -->
                <div class="c-btn-area">
                  <button
                    type="button"
                    class="c-button type-white type-xsmall"
                    @click="btnCmd('basket', item)"
                  >
                    <span>장바구니</span>
                  </button>
                  <button
                    type="button"
                    class="c-button type-primary type-xsmall"
                    @click="btnCmd('quickOrder', item)"
                  >
                    <span>바로주문</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- D: 스와이퍼 indicator 별도 적용 영역 -->
    <div
      v-if="!isMobile.value"
      class="c-swiper-indicator"
      data-swiper-indicator-id="swiperCol2"
    ></div>
  </div>

  <ProdInfoPop
    v-if="isShowProdInfoPop"
    v-bind="prodInfoPopProps"
    @close="() => (isShowProdInfoPop = false)"
  />
</template>

<script setup name="main02Swiper">
import {
  onMounted,
  reactive,
  inject,
  defineProps,
  watch,
  nextTick,
  ref,
  provide,
  readonly,
} from "vue";

import ProdInfoPop from "@/components/paintpro/prod/prodInfoPop.vue";

import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil.js";
import * as orderApi from "@/api/orderApi.js";

import { api } from "@/plugins/api";

//Swiper
import Swiper, { Pagination, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
// import { set } from "lodash";

const { isMobile } = cmUtil.useDeviceType();
const FILE_CDN_URL = process.env.VUE_APP_FILE_CDN_URL;
const url = inject("url_prefix");
const swiperInstance = ref(null);

const props = defineProps({
  type: {},
  option: {},
  data: {
    type: Object,
    required: true,
  },
  zempNo: {},
});

const data = reactive({
  codes: {
    WERKS: [],
    CODE_GOODS_FILE_SE_CD: [],
  },
  swiper: {
    loading: false,
    type: {},
    tabType: "",
    search: {},
    data: [],
  },
  popup: {
    isShowProdInfoPop: false, // 제품상세
  },
});

watch(
  () => props.data,
  (newValue) => {
    data.swiper.search = newValue;
    mainSwiper02();
  }
);

// 탭 바꿀때마다 조회
watch(
  () => props.type,
  (orderValue) => {
    data.swiper.search.fashionRcmdtnSeCd = orderValue;
    mainSwiper02();
  }
);
// 상단 영업사원이 변경 되는 경우
watch(
  () => props.zempNo,
  (empValue) => {
    data.swiper.search.matkl = empValue;
    mainSwiper02();
  }
);

// 제품상세팝업
const isShowProdInfoPop = ref(false);
const prodInfoPopProps = ref({
  matnr: null,
});
provide("CODE_WERKS", readonly(data.codes.CODE_WERKS));
provide("CODE_GOODS_FILE_SE_CD", readonly(data.codes.CODE_GOODS_FILE_SE_CD));

/**********************
 * 스와이퍼 호출
 *********************/
async function initSwiper() {
  if (!isMobile.value) {
    // 기존 인스턴스 파괴
    if (swiperInstance.value) {
      swiperInstance.value.destroy(true, true);
      swiperInstance.value = null;
    }

    // nextTick을 사용하여 DOM 업데이트 보장
    await nextTick();

    swiperInstance.value = new Swiper("[data-swiper-id='swiperCol2']", {
      modules: [Pagination, Autoplay],
      init: true,
      initialSlide: 0,
      speed: 400,
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      observer: true,
      observeParents: true,
      autoplay: {
        delay: data.swiper?.data.length > 1 ? 2000 : 99999000,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: '[data-swiper-indicator-id="swiperCol2"]',
        type: "bullets",
        clickable: true,
      },
    });
  }
}

async function initData() {
  // ◼◼◼ 초기데이타 조회
  const mparm = [];
  mparm.push({ qId: "cmCode_code1", parm: { cdGrp: "WERKS" } });
  mparm.push({ qId: "cmCode_code2", parm: { cdGrp: "GOODS_FILE_SE_CD" } });

  const res = await cmApi.getPageInitData(mparm);
  const { resultCode } = res;
  if (resultCode !== 200) {
    // alert(`errror : resultCode:${resultCode}, message:${message}`);
    return false;
  }

  data.codes.WERKS = res.data.cmCode_code1;
  data.codes.CODE_GOODS_FILE_SE_CD = res.data.cmCode_code2;
}

/**********************
 * 조회 모음
 *********************/
async function mainSwiper02() {
  const res = await api.post(`${url}/main/mainSwiper02`, {
    ...props.data,
  });

  var swiper02 = []; //스와이퍼 목록
  var itemList = []; //1페이지 2제품 리스트
  var listIdx = res.data.length - 1;

  res.data.forEach((item, idx) => {
    var param = {
      /* 뱃지영역 */
      fashionRcmdtnTurn: item.fashionRcmdtnTurn,
      zzlqdCls: item.zzlqdCls,
      zzlqdtyCls: item.zzlqdtyCls,
      setgdYn: item.setgdYn,
      prodh1t: item.prodh1t,
      prodh2t: item.prodh2t,
      prodh3t: item.prodh3t,
      /* 상품정보 */
      matnr: item.matnr,
      zzmaktx: item.zzmaktx,
      kbetr: item.kbetr,
      imgUrl: FILE_CDN_URL + item.filePath + "/" + item.physFileNm,
      noImgFlag: item.physFileNm == null ? true : false,
      goodsSn: item.goodsSn,
    };
    itemList.push(param);

    //1페이지 2제품이 되도록 리스트 나눠서 담기
    if (idx % 2 == 1) {
      swiper02.push(itemList);
      itemList = [];
    } else if (idx == listIdx) {
      swiper02.push(itemList);
    }
  });

  data.swiper.data = swiper02;

  await nextTick();
  initSwiper();
}

/**********************
 * 버튼 동작 모음
 *********************/
// 자주찾는 메뉴 세팅 팝업
async function btnCmd(cmd = "", params = {}) {
  // 제품 상세보기 팝업
  if (cmd == "detail") {
    prodInfoPopProps.value.matnr = params.matnr;
    isShowProdInfoPop.value = true;
  }
  // 장바구니 추가
  else if (cmd == "basket") {
    cmApi.insertUserBasketProd({
      goodsSn: params.goodsSn,
      goodsQty: 1,
    });
  }
  // 바로주문
  else if (cmd == "quickOrder") {
    const param = {
      goodsSn: params.goodsSn,
      goodsQty: 1,
      zempNo: props.data.kunn2,
      path: "",
    };
    await orderApi.createTempOrder(param);
  }
}

// 상세팝업에서 바로주문
const addBuyItem = async (product) => {
  const param = {
    goodsSn: product.goodsSn,
    goodsQty: 1,
    zempNo: props.data.kunn2,
    path: "",
  };

  await orderApi.createTempOrder(param);
};
provide("addBuyItem", addBuyItem);

const addCartItem = async (param = { product: null, quantity: 0 }) => {
  await cmApi.insertUserBasketProd({
    goodsSn: param.product.goodsSn,
    zzlqdCls: param.product.zzlqdCls,
    goodsQty: 1,
  });
};
provide("addCartItem", addCartItem);

/**********************
 * 마운트
 *********************/
onMounted(() => {
  initData();
});
</script>
